import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-underline-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="currentColor"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M16.6663 18.5H7.33301C7.05967 18.5 6.83301 18.2733 6.83301 18C6.83301 17.7267 7.05967 17.5 7.33301 17.5H16.6663C16.9397 17.5 17.1663 17.7267 17.1663 18C17.1663 18.2733 16.9397 18.5 16.6663 18.5Z" />
      <path
        d="M11.9997 15.8333C9.15301 15.8333 6.83301 13.5133 6.83301 10.6667V6C6.83301 5.72667 7.05967 5.5 7.33301 5.5C7.60634 5.5 7.83301 5.72667 7.83301 6V10.6667C7.83301 12.9667 9.69967 14.8333 11.9997 14.8333C14.2997 14.8333 16.1663 12.9667 16.1663 10.6667V6C16.1663 5.72667 16.393 5.5 16.6663 5.5C16.9397 5.5 17.1663 5.72667 17.1663 6V10.6667C17.1663 13.5133 14.8463 15.8333 11.9997 15.8333Z" />
    </svg>
  `,
})
export class UnderlineIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
